window.addEventListener('DOMContentLoaded', () => {
  // Get all "trigger" elements
  const $trigger = Array.prototype.slice.call(
    document.querySelectorAll('.u-trigger'),
    0,
  );

  // Check if there are any navbar burgers
  if ($trigger.length > 0) {
    // Add a click event on each of them
    $trigger.forEach(el => {
      el.addEventListener('click', e => {
        e.preventDefault();
        // Get the target from the "data-target" attribute
        const { target, triggerClassName: className } = el.dataset;
        const { triggerClose, triggerCloseId } = el.dataset;
        const targetArr = target.split(',');

        if(triggerClose) {
          const $closeElms = document.querySelectorAll('[data-id="'+triggerClose+'"]');
          $closeElms.forEach(closeElm =>  {
            if(el.dataset.target !== closeElm.id) {
              closeElm.classList.remove(className || 'is-active');

              if (closeElm.hasAttribute('aria-expanded')) {
                closeElm.setAttribute('aria-expanded', 'false');
              }
            }
          });
        }

        if(triggerCloseId) {
          const $closeElms = document.querySelectorAll('[data-trigger-close-id="'+triggerCloseId+'"]');
          $closeElms.forEach(closeElm =>  {
            if(el.dataset.target !== closeElm.dataset.target) {
              closeElm.classList.remove(className || 'is-active');

              if (closeElm.hasAttribute('aria-expanded')) {
                closeElm.setAttribute('aria-expanded', 'false');
              }
            }
          });
        }

        targetArr.forEach(t => {
          const $target = document.getElementById(t);
          $target.classList.toggle(className || 'is-active');
        });

        el.classList.toggle(className || 'is-active');

        // Update aria data if exist
        if (el.hasAttribute('aria-expanded')) {
          const attr = el.getAttribute('aria-expanded');
          const isTrue = attr === 'true';
          el.setAttribute('aria-expanded', !isTrue ? 'true' : 'false');
        }

        // To save the user a click more
        if (targetArr.find(targetName => targetName === 'searchform')) {
          const $target = document.getElementById(target);

          if ($target) {
            const firstInput = $target.querySelector('input');

            firstInput.focus();

            // More UX sugar
            if (firstInput.value.length > 0) {
              firstInput.select();
            }
          }
        }
      });
    });
  }
});
